<style>
    .row {
        margin-left: 0px;
        margin-right: 0px;
    }

    .panel-heading {
        padding: 5px;
    }

    .panel-body {
        background-color: #f2f6fa;
        padding: 20px;
    }

    #mapDiv {
        height: 700px;
    }

    #news {
        color: #4c637b;
    }

    #news a:hover {
        text-decoration: none;
    }

    .back-top {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 1;
        width: 50px;
        height: 50px;
        background: #344C67;
    }

</style>

<div class="row" style="padding-top:15px; padding-bottom:30px; padding-left:15px">
    <div class="col-md-12">

        <h3>Help Documentation</h3>
        <div class="panel">

            <div class="col-md-6" style="color:#4C637B;">
                WALTERS is a spatially linked electronic document storage system and your go-to product for data
                storage, access, management, and sharing.
                Identify facilities, sites, or places of environmental interest in Guam, and attach them to a
                geographic
                location for
                easy discovery.
                <br><br>We hope that continued use of the system will support daily activities and data
                maintenance and
                allow Guam EPA staff to stay informed as important information becomes available in their area of
                interest.
                By integrating WALTERS into your workflow, we can help make Guam a better place to live and work,
                while sharing tools for better environmental outcomes.
                <br> <br>
                The WALTERS interface features four main pages: <b>Dashboard</b>, <b>Sites</b>, <b>Map Tool</b>, and
                <b>Beaches</b>.
                <br><br>Use this Help Documentation to find descriptions of each page, including featured data and
                tools. Use the <i class="fa fa-question-circle"></i> next to your name in the upper right-hand
                corner of
                the site
                at any time to see general help documentation specific to your current page.
            </div>

            <div class="col-md-6" style="color:#4C637B;">
                Additional help can be found by clicking the <i class="fa fa-question-circle"></i> icons throughout
                the
                website. For example, click the icon
                to find full explanations of each tool included in the "Actions" drop-down on the Sites page:
                <br>
                <div style="text-align: center"><img src="/static/helpdocsImages/helpExample.png" style="padding-right:10px"></div>
                <br>The associated help documentation will appear on the page:
                <br>
                <div style="text-align: center"><img src="/static/helpdocsImages/actionHelp.png" style="padding-right:10px"></div>
                <br>
            </div>

            <div class="col-md-12">
                <br>
                <div class="row" *ngFor="let help_section of included_help" id="{{ help_section }}">
                    <div class="col-md-12">
                        <h3 [innerHTML]="title[help_section]" style="color:#12203C"></h3>
                        <p [innerHTML]="short_text[help_section]"></p>
                    </div>
                    <br>
                </div>

            </div>

        </div>
        <!--         <help-docs-open record-type="dashboard"></help-docs-open>-->

    </div>

</div>
<!--<back-top></back-top>-->
